import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const AlbumRepository = RepositoryFactory.get('album');

const itemsPerPage = 15;

const state = {
  themes: [],
  series: [],
  seasons: [
    { name: 'Alle seizoenen', id: 'all-seasons' },
    { name: 'Winter', id: 'winter' },
    { name: 'Lente', id: 'spring' },
    { name: 'Zomer', id: 'summer' },
    { name: 'Herfst', id: 'autumn' }
  ],
  items: [],
  pagination: {
    current_page: 0, last_page: 0, per_page: itemsPerPage
  },
  itemsPerPage,
  loading: false
}

const actions = {
  getThemes ({ commit }) {
    return new Promise((resolve, reject) => {
      return AlbumRepository.getThemes().then(response => {
        const data = response.data.data;
        commit('SET_THEMES', data);
        resolve(data);
      }).catch((error) => {
        commit('SET_THEMES', null);
        reject(error);
      });
    })
  },
  getSeries ({ commit }) {
    return new Promise((resolve, reject) => {
      return AlbumRepository.getSeries().then(response => {
        const data = response.data.data;
        commit('SET_SERIES', data);
        resolve(data);
      }).catch((error) => {
        commit('SET_SERIES', null);
        reject(error);
      });
    })
  },
  getItems ({ commit }, queryParams) {
    commit('SET_LOADING', true);

    return new Promise((resolve, reject) => {
      return AlbumRepository.getItems(queryParams).then(response => {
        const data = response.data;

        // get paging info
        if (data) {
          commit('SET_PAGINATION', {
            current_page: Math.max(Math.ceil(data.to / state.itemsPerPage), 1), // needed when loading multiple items
            last_page: data.last_page,
            per_page: data.from_page
          });
        } else {
          commit('SET_PAGINATION', {
            current_page: 0,
            last_page: 0,
            per_page: state.pagination
          });
        }

        let items = [];

        if (data.data) {
          // inject appearIndex used in masonry to show items one by one
          let appearIndex = 0;
          for (var i = 0; i < data.data.length; i++) {
            data.data[i].appearIndex = appearIndex++;
          }

          // first page is loaded, clear previous items
          if (data.current_page === 1) {
            items = data.data;
          } else {
            // next page is loaded, keep current items and add new ones
            items = state.items.concat(data.data);
          }
        }

        commit('SET_ITEMS', items);
        commit('SET_LOADING', false);
        resolve(data);
      }).catch((error) => {
        commit('SET_ITEMS', null);
        commit('SET_LOADING', false);
        reject(error);
      });
    })
  }
}

const mutations = {
  SET_THEMES (state, themes) {
    state.themes = themes;
  },
  SET_SERIES (state, series) {
    state.series = series;
  },
  SET_ITEMS (state, items) {
    state.items = items;
  },
  SET_PAGINATION (state, pagination) {
    state.pagination = pagination;
  },
  SET_LOADING (state, loading) {
    state.loading = loading;
  }
}

const getters = {
  getThemes: state => state.themes,
  getSeasons: state => state.seasons,
  getSeries: state => state.series,
  getItems: state => state.items,
  getPagination: state => state.pagination,
  getItemsPerPage: state => state.itemsPerPage,
  getLoading: state => state.loading
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
